import { Box, Divider } from "@mui/material";
import { TraderAvatar } from "src/components/common/trader-avatar";
import { Typography } from "src/components-mui/base/typography/typography";
import { HoverCard, IHoverCardProps } from "src/components-mui/common/hover-card/hover-card";
import { Ranking } from "src/components-mui/common/ranking/ranking";
import { IHeroSliderWikifolioData } from "src/components-mui/modules/hero-module/hero-slider-module.types";
import { useGetUserName } from "src/hooks/use-get-user-name";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface IHeroSliderWikifolioCardProps extends IHeroSliderWikifolioData {
    sx?: IHoverCardProps["sx"];
}

export const HeroSliderWikifolioCard = ({ trader, symbol, shortDescription, firstRanking, secondRanking, sx }: IHeroSliderWikifolioCardProps) => {
    const { buildWikifolioLink } = useLinkBuilder();
    const getUserName = useGetUserName();

    return (
        <HoverCard
            component="a"
            href={buildWikifolioLink(symbol)}
            sx={[{ display: "flex", flexDirection: "column", width: ["292px", "292px", "318px"] }, ...(Array.isArray(sx) ? sx : [sx])]}
        >
            <Box
                sx={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    marginBottom: 1,
                }}
            >
                <TraderAvatar size={["lg", "lg", "xl"]} trader={trader} mr={1} />
                <Box
                    sx={{
                        overflow: "hidden",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: ["md", "md", "lg"],
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {getUserName(trader)}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: ["xs", "xs", "sm"],
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            mt: 0.5,
                        }}
                    >
                        {shortDescription}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                    justifyContent: "center",
                }}
            >
                <Ranking size="md" data={firstRanking} sx={{ alignItems: "center", alignContent: "center", width: "50%" }} hidePoints />
                <Divider orientation="vertical" sx={{ height: "49px" }} />
                <Ranking size="md" data={secondRanking} sx={{ alignItems: "center", alignContent: "center", width: "50%" }} hidePoints />
            </Box>
        </HoverCard>
    );
};
